// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"96ff7d38","239":"1fd735eb","455":"956cf9ea"}[chunkId] + ".chunk.js";
};